module.exports = __webpack_public_path__ + "static/img/lg-ess-img-03-02@w.474d069.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-ess/lg-ess-img-03-02@w.jpg
// module id = Bi6u
// module chunks = 0